module.exports = __webpack_public_path__ + "img/img_sub_prod_brityrpa02.edaba38e.svg";